
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-12 sm:py-16 overflow-hidden">
      <div className="container mx-auto px-4 max-w-full">
        <div className="grid md:grid-cols-3 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* 会社情報 */}
          <div className="min-w-0">
            <div className="mb-4 sm:mb-6">
              <img 
                src="https://static.readdy.ai/image/4e28e17ba4e737ad2b4d0213d4252ea8/73be6e95a9cc4159c8afb514f102f80a.png" 
                alt="訪問介護のんな福島" 
                className="h-10 sm:h-12 w-auto max-w-full"
              />
            </div>
            <div className="space-y-2 sm:space-y-3">
              <div className="text-base sm:text-lg">
                <div className="font-semibold break-words">訪問介護のんな福島</div>
                <div className="text-gray-300 break-words">株式会社りえぞん</div>
              </div>
              <div className="text-gray-300 text-sm sm:text-base leading-relaxed break-all">
                〒960-8055<br />
                福島県福島市野田町7-13-50-2階
              </div>
              <div className="text-gray-300 text-sm sm:text-base">
                介護事業所番号: 770106425
              </div>
            </div>
          </div>

          {/* 連絡先 */}
          <div className="min-w-0">
            <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 break-words">お問い合わせ</h3>
            <div className="space-y-3 sm:space-y-4">
              <div className="flex items-center min-w-0">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-pink-600 rounded-full flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0">
                  <i className="ri-phone-fill text-white text-sm sm:text-lg"></i>
                </div>
                <div className="min-w-0">
                  <a href="tel:024-563-7717" className="text-lg sm:text-xl font-semibold hover:text-pink-400 transition-colors whitespace-nowrap">
                    024-563-7717
                  </a>
                  <div className="text-gray-300 text-xs sm:text-sm">平日 8:00〜18:00</div>
                </div>
              </div>
              <div className="flex items-center min-w-0">
                <div className="w-6 h-6 sm:w-8 sm:h-8 bg-pink-600 rounded-full flex items-center justify-center mr-2 sm:mr-3 flex-shrink-0">
                  <i className="ri-mail-fill text-white text-sm sm:text-lg"></i>
                </div>
                <div className="min-w-0">
                  <div className="text-base sm:text-lg break-words">お問い合わせフォーム</div>
                  <div className="text-gray-300 text-xs sm:text-sm">24時間受付</div>
                </div>
              </div>
            </div>
          </div>

          {/* サービス */}
          <div className="min-w-0">
            <h3 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6 break-words">サービス</h3>
            <ul className="space-y-2 text-gray-300 text-sm sm:text-base">
              <li className="hover:text-white transition-colors cursor-pointer break-words">身体介護</li>
              <li className="hover:text-white transition-colors cursor-pointer break-words">生活援助</li>
              <li className="hover:text-white transition-colors cursor-pointer break-words">医療連携</li>
              <li className="hover:text-white transition-colors cursor-pointer break-words">24時間対応</li>
              <li className="hover:text-white transition-colors cursor-pointer break-words">認知症ケア</li>
              <li className="hover:text-white transition-colors cursor-pointer break-words">相談・相談支援</li>
            </ul>
          </div>
        </div>

        {/* クイックリンク */}
        <div className="border-t border-gray-700 pt-6 sm:pt-8 mb-6 sm:mb-8">
          <nav className="flex flex-wrap justify-center gap-4 sm:gap-8 text-base sm:text-lg">
            <a href="#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              私たちについて
            </a>
            <a href="#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              サービス内容
            </a>
            <a href="#recruitment" className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              求人情報
            </a>
            <a href="#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer whitespace-nowrap">
              お問い合わせ
            </a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-white transition-colors whitespace-nowrap">
              Made with Readdy
            </a>
          </nav>
        </div>

        {/* コピーライト */}
        <div className="text-center text-gray-400">
          <p className="text-base sm:text-lg break-words">
            © 2023 訪問介護のんな福島 All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
